<template>
  <div class="header-container" style="height: auto;">
    <div class="header-content" style="z-index: 99999;">
      <div class="icon-content" @click="handleBack">
        <img src="../assets/back_icon@3x.png" />
      </div>
      <div class="header-title">
        {{ title }}
      </div>
      <div class="heder-search">
        <router-link class="search-entry" :to="{ name: 'search' }">
          <img src="@/assets/search_icon@3x.png" />
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: () => {
        return '';
      },
    },
  },
  name: 'page-header',
  methods: {
    handleBack() {
      console.log(document.referrer);
      document.referrer != null && document.referrer != undefined && document.referrer != ''
        ? this.$router.back()
        : this.$router.push('/');
      //this.$router.back();
    },
  },
};
</script>

<style lang="sass" scoped src="./header.sass"></style>
